import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  container: {
    padding: 14,
    paddingBottom: 18,
    gap: 12,
  },
  loadingWrap: {
    height: '100%',
    minHeight: 260,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  hero: {
    borderRadius: 12,
    paddingHorizontal: 14,
    paddingVertical: 13,
    backgroundColor: '#DDF8F2',
    borderWidth: 1,
    borderColor: 'rgba(61, 171, 158, 0.22)',
  },
  heroTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  heroIcon: {
    width: 28,
    height: 28,
    borderRadius: 9,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: 'rgba(61, 171, 158, 0.24)',
  },
  heroKicker: {
    color: '#2F8E83',
    fontSize: 12,
    fontWeight: '900',
    textTransform: 'uppercase',
  },
  heroTitle: {
    color: '#262322',
    fontSize: 18,
    fontWeight: '900',
    lineHeight: 23,
  },
  heroSubtitle: {
    marginTop: 5,
    color: '#73695F',
    fontSize: 12,
    fontWeight: '700',
    lineHeight: 17,
  },
  statGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  statTile: {
    flexGrow: 1,
    flexBasis: '47%',
    minWidth: 116,
    minHeight: 78,
    borderRadius: 10,
    padding: 10,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: 'rgba(77, 63, 55, 0.10)',
  },
  statIcon: {
    width: 25,
    height: 25,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F2FBF8',
    marginBottom: 8,
  },
  statLabel: {
    color: '#8F7A65',
    fontSize: 11,
    fontWeight: '800',
    lineHeight: 14,
  },
  statValue: {
    marginTop: 2,
    color: '#262322',
    fontSize: 15,
    fontWeight: '900',
    lineHeight: 20,
  },
  section: {
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: 'rgba(77, 63, 55, 0.10)',
    overflow: 'hidden',
  },
  sectionHeader: {
    minHeight: 38,
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: '#FFF8E4',
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(250, 207, 71, 0.32)',
  },
  sectionTitle: {
    color: '#4D3F37',
    fontSize: 12,
    fontWeight: '900',
    textTransform: 'uppercase',
  },
  sectionRows: {
    paddingHorizontal: 12,
    paddingVertical: 4,
  },
  infoRow: {
    paddingVertical: 10,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: 'rgba(77, 63, 55, 0.12)',
  },
  infoRowWide: {
    minWidth: '100%',
  },
  infoLabel: {
    color: '#8F7A65',
    fontSize: 11,
    fontWeight: '800',
    lineHeight: 14,
    marginBottom: 3,
  },
  infoValue: {
    color: '#342B26',
    fontSize: 13,
    fontWeight: '800',
    lineHeight: 18,
    wordBreak: 'break-word',
  },
  infoValueLink: {
    color: '#2F8E83',
    textDecorationLine: 'underline',
  },
  playersRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'baseline',
  },
});

export default styles;
